<template>
<form ref="form" class="small-padding"
	@keyup.enter="submit">
	<h3>
		<span v-show="act === 'login'">
			Login to RPH
		</span>
		<span v-show="act !== 'login'">
			Create a new RPH account
		</span>
	</h3>
	<!--<p class="margin-bottom">
			<a
				v-show="act === 'login'"
				@click="act = 'register'">
				create a new account instead
			</a>
			<a
				v-show="act === 'register'"
				@click="act = 'login'">
				login instead
			</a>
		</p>-->
	<label for="name">
		<span v-show="act === 'login'">Character Name <em>or</em> Email</span>
		<span v-show="act === 'register'">Character Name</span>
	</label>
	<input id="name" v-model="login" type="text"
		name="name"
	>
	<div class="flex-parent">
		<label for="password">Password</label>
		<span class="right">
			<a v-show="showPassword === false"
				@click="showPassword = true">
				Show
			</a>
			<a v-show="showPassword === true"
				@click="showPassword = false">
				Hide
			</a>
		</span>
	</div>
	<div class="flex-parent">
		<input id="password" v-model="password"
			name="password"
			autocomplete="off"
			:type="showPassword ? 'text' : 'password'">
		<input v-show="act === 'register'" id="repeatPassword" v-model="repeatPassword"
			name="repeatPassword"
			placeholder="Confirm Password"
			autocomplete="off"
			:type="showPassword ? 'text' : 'password'">
	</div>
	<div v-if="act === 'register'">
		<label for="email">
			Email
		</label>
		<input id="email" v-model="email" type="text"
			name="email"
		>
		<label for="agree">
			<input id="agree" v-model="agree" type="checkbox"
				name="agree"
			>
			I am at least 18 years old
		</label>
		<div class="h-captcha" data-sitekey="2952c61d-2d0e-4ec3-beeb-9bd34d54fba0" />
	</div>
	<input type="button" class="margin-top small-padding wide"
		:disabled="submitting"
		:value="submitting ? 'This may take a minute...' : act === 'login' ? 'Login' : 'Register'"
		@click="submit"
	>
	<p> {{ msg }} </p>
	<!--<a>Recover lost password</a>-->
</form>
</template>

<script>
import socket from '../js/socket.js'
import rph from '../js/rph.js'

export default {
	components: {
	},
	data: () => ({
		msg: '',
		showPassword: false,
		password: null,
		repeatPassword: null,
		login: null,
		email: null,
		agree: false,
		submitting: false,
		act: 'login'
	}),
	watch: {
		password: 'matchPasswords',
		repeatPassword: 'matchPasswords',
		login(){
			if( this.login < 3 ){
				this.msg = 'Character name must be at least 3 letters'
			} else {
				this.msg = ''
			}
		},
		email(){
			this.msg = ''
			if( !this.email.includes( '@' ) || this.email.indexOf( '.' ) < this.email.length - 7 || this.email.indexOf( '.' ) > this.email.length - 3 ){
				this.msg = 'Email address is not valid'
			}
		},
		act( value ){
			if( value === 'login' ){
				this.msg = ''
			} else if( value === 'register' ){
				this.matchPasswords()
			}
		}
	},
	mounted(){
		socket.on( 'login-error', ( msg ) => {
			this.msg = msg
			this.enableSubmit()
		})
		socket.once( 'account', () => {
			if( rph.dialogs.Login ){
				rph.dialogs.Login.hide()
			}
			this.enableSubmit()
		})
	},
	methods: {
		submit(){
			const { login, password, email } = this
			if( this.act === 'login' ){
				socket.emit( 'login', {
					login,
					password
				})
				console.log( 'login sent for', login )
			} else if( this.act === 'register' ){
				if( this.msg !== '' ){ // has errors..
					this.msg = 'Fix errors before submission'
					return
				}
				const formData = new FormData( this.$refs.form )
				console.log( this.$refs.form, formData.get( 'h-captcha-response' ) )
				socket.emit( 'register', {
					login,
					password,
					email,
					captcha: formData.get( 'h-captcha-response' )
				})
			}
			this.submitting = true
		},
		enableSubmit(){
			this.submitting = false
		},
		matchPasswords(){
			if( this.act !== 'register' ){
				this.msg = ''
			} else {
				if( this.password !== this.repeatPassword ){
					this.msg = 'Passwords do not match'
				} else {
					this.msg = ''
				}
			}
		}
	}
}
</script>